<template>
  <a-layout class='index animated fadeIn'>
    <a-card class="m-t-10" :bordered='false'>
      <a-button size='small' @click="()=>{$router.go(-1)}">
        <LeftOutlined />返回
      </a-button>
      <span class="ml15 fz-20" v-if='$route.query.type == "look"'>带参数二维码详情</span>
      <span class="ml15 fz-20" v-else>{{$route.query.type == 'add' ? '添加':'修改'}}带参数二维码</span>
    </a-card>
    <a-card :bordered='false'>
      <a-form ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-item ref="name" label="二维码名称" name="name">
          <a-input v-model:value="form.name" placeholder='请输入二维码名称' :readonly="$route.query.type == 'look'"/>
        </a-form-item>
        <a-form-item ref="" label="二维码分类" name="">
          <a-select v-model:value="form.cate_id" placeholder="请选择二维码分类">
            <a-select-option v-for='item in typeList' :key='item.id' :value="item.id" :disabled="$route.query.type == 'look'">{{item.name}}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item ref="" label="自动回复" name="" style="position:relative">
          <!-- 禁止 -->
          <div style="height:4000px;opacity:0;position:absolute;zIndex:10;width:70vw;" v-if="$route.query.type == 'look'"></div>
          <div class="s_bor_cd9 ">
             
            <div class="height-38 s_flex_bian_c m-t-2 p-l-11 p-r-11">
              <div class="s_flex_ali">
                <p class="width-120 s_shou" @click='addTextOpen("")' :disabled="$route.query.type == 'look'">
                  <EditOutlined class="m-r-10 fz-16" />文字
                </p>
                <div class="width-120 s_shou s_po_re">
                  <PictureOutlined class="m-r-10 fz-16" />图片
                <div class="s_po_ab_tl s_tou" v-if='form.replys.length < 5'>
                  <wxMaterial :size='{width:120,height:40}' :groupType='1' :image="file_url" :max="1" v-on:handlechoose="selectImg" />
                </div>
                <div v-else class="s_po_ab_tl s_tou width-120 height-40" @click='openSelectImgText' :disabled="$route.query.type == 'look'"></div>
                </div>
                <p class="width-120 s_shou" style="overflow:hidden" @click='openSelectImgText' :disabled="$route.query.type == 'look'">
                  <FileImageOutlined class="m-r-10 fz-16" />图文
                </p>
              </div>
              <div class="s_flex_ali">
                <a-checkbox v-model:checked="form.reply_all" @change="onChange" :disabled="$route.query.type == 'look'" >全部回复</a-checkbox>
                <a-tooltip >
                  <template #title >
                    提示：未选择“回复全部”时，则按照图文信息、图片信息、文字信息的顺序回复。
                  </template>
                  <QuestionCircleOutlined class="s_c376" style="zIndex:20;"/>
                </a-tooltip>
              </div>
            </div>
            <div>
              <div class="p-t-10 p-l-24 p-b-10 p-r-24 s_bor_t_cd9 s_flex_bian" v-for='(items,indexs) in form.replys' :key='indexs'>
                <div class="clearfix">
                  <p class="m-r-20 fl">{{items.type_name}}</p>
                  <p class="fl" v-if='items.type== 1'>{{items.content}}</p>
                  <p class="fl" v-if='items.type== 3 || items.type== 4'>{{items.title}}</p>
                  <img v-if='items.type== 2' class="width-110 height-110" :src="items.image.indexOf(info.picdomain) == -1 ? info.picdomain+'/'+items.image : items.image" alt="">
                </div>
                <div>
                  <EditOutlined v-if='items.type== 1' @click='addTextOpen(indexs)' :disabled="$route.query.type == 'look'" class="m-r-30 fz-16 s_shou" />
                  <DeleteFilled class="fz-16 s_shou" @click='delreplyItem(indexs)' :disabled="$route.query.type == 'look'" />
                </div>
              </div>
            </div>
          </div>
        </a-form-item>
        <a-form-item ref="" label="指定客户标签" name="">
          <a-select mode="multiple" v-model:value="form.wx_tag_id" style="width: 100%" placeholder="请选择客户标签">
            <a-select-option v-for="item in tagList" :key="item.id" :disabled="$route.query.type == 'look'">{{item.name}}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :wrapper-col="{ span: 8, offset: 2 }" v-if='$route.query.type != "look"'>
          <a-button type="primary" @click="onSubmit">
            保存
          </a-button>
        </a-form-item>
      </a-form>
    </a-card>
  </a-layout>
  <a-modal  :keyboard="false" title="添加文字回复" :width='800' centered v-model:visible="visible" destroyOnClose @ok="addTextItem" @cancel='textContent = "";textIndex = ""'>
    <a-textarea v-model:value="textContent" showCount :maxlength="600" :rows='8' placeholder='请输入' />
  </a-modal>
  <a-modal  :keyboard="false" title="选择图文" :width='1300' centered :footer="null" v-model:visible="graphicVisible" destroyOnClose>
    <graphic v-on:success='success' v-on:cancel='graphicVisible = false' />
  </a-modal>
</template>
<script>
import {
  EditOutlined,
  PictureOutlined,
  FileImageOutlined,
  DeleteFilled,
  QuestionCircleOutlined,
  LeftOutlined,
} from "@ant-design/icons-vue";
import { ref, onMounted, reactive, toRefs, inject } from "vue";
import { message } from "ant-design-vue";
import {
  wx_qrcode_Edit,
  wx_qrcode_Add,
  getwx_qrcode_cate,
  getwx_qrcodeMore,
  getTagList,
} from "@/api/public_wx";
import store from "@/store";
import { iscode } from "@/utils/app";
// 初始化默认筛选项数值
let defForm = {
  name: "",
  cate_id: undefined,
  wx_tag_id: [],
  reply_all: 0,
  replys: [],
};
export default {
  components: {
    EditOutlined,
    PictureOutlined,
    FileImageOutlined,
    DeleteFilled,
    QuestionCircleOutlined,
    LeftOutlined,
  },
  setup() {
    const ruleForm = ref();
    const $route = inject("$route");
    const $router = inject("$router");
    const _lodash = inject("_lodash");
    const form = ref(_lodash.cloneDeep({ ...defForm }));
    const state = reactive({
      info: store.state.user.info,
      textIndex: "",
      textContent: "",
      graphicVisible: false,
      typeList: [],
      tagList: [],
      visible: false,
      loading: false,
      labelCol: { span: 3 },
      wrapperCol: { span: 16 },
      rules: {
        name: [{ required: true, message: "请输入二维码名称" }],
      },
    });
    // 获取详情
    const getMore = async (id) => {
      const hide = message.loading("正在加载中...", 0);
      let res = await getwx_qrcodeMore({ id: id }).then((res) => res.data);

      if (iscode(res)) {
        form.value = res.data;
        form.value.replys = _lodash.concat(
          res.data.replyText || [],
          res.data.replyImage || [],
          res.data.replyGraphic || []
        );
        form.value.wx_tag_id = JSON.parse(res.data.wx_tag_id);
        setTimeout(hide);
      } else {
        message.error(res.msg);
        setTimeout(hide);
      }
    };
    // 获取分类
    const getType = async () => {
      let res = await getwx_qrcode_cate({ page: 1, limit: 20 }).then(
        (res) => res.data
      );
      if (iscode(res)) {
        state.typeList = res.data.data;
      } else {
        message.error(res.msg);
      }
    };
    // 获取标签列表
    const getTag = async () => {
      let res = await getTagList().then((res) => res.data);
      if (iscode(res)) {
        state.tagList = res.data.tags;
      } else {
        message.error(res.msg);
      }
    };
    // 打开添加文字内容
    const addTextOpen = (index) => {
      if (index !== "") {
        state.visible = true;
        state.textIndex = index;
        state.textContent = form.value.replys[index].content;
      } else {
        if (form.value.replys.length == 5) {
          message.error("每条规则最多设置5条回复");
        } else {
          state.visible = true;
        }
      }
    };
    // 添加文字内容
    const addTextItem = () => {
      if (state.textContent == "") {
        message.error("文字必须为1到600个字。");
      } else {
        if (state.textIndex === "") {
          form.value.replys.push({
            type: 1,
            content: state.textContent,
            type_name: "文字",
          });
          state.visible = false;
          state.textContent = "";
          state.textIndex == "";
        } else {
          form.value.replys[state.textIndex].content = state.textContent;
          state.visible = false;
          state.textContent = "";
          state.textIndex == "";
        }
      }
    };
    //选择图片
    const selectImg = (data) => {
      form.value.replys.push({
        type: 2,
        content: data.data.media_id,
        type_name: "图片",
        image: data.imageUrl,
      });
    };
    //选择图文
    const success = (e) => {
      form.value.replys.push({
        type: e.media_id ? 3 : 4,
        content: e.media_id ? e.media_id : e.id,
        type_name: "图文",
        title: e.list[0].title,
      });
      state.graphicVisible = false;
    };
    // 打开选择图文
    const openSelectImgText = () => {
      if (form.value.replys.length == 5) {
        message.error("每条规则最多设置5条回复");
        return false;
      }
      state.graphicVisible = true;
    };
    // 删除回复
    const delreplyItem = (index) => {
      form.value.replys.splice(index, 1);
    };
    const onSubmit = () => {
      ruleForm.value
        .validate()
        .then(async () => {
          let res;
          const hide = message.loading("正在加载中...", 0);
          if ($route.query.type == "add") {
            res = await wx_qrcode_Add({
              ...form.value,
              wx_tag_id: JSON.stringify(form.value.wx_tag_id),
              replys: JSON.stringify(form.value.replys),
            }).then((res) => res.data);
          } else {
            res = await wx_qrcode_Edit({
              ...form.value,
              wx_tag_id: JSON.stringify(form.value.wx_tag_id),
              replys: JSON.stringify(form.value.replys),
            }).then((res) => res.data);
          }
          if (iscode(res)) {
            setTimeout(hide);
            message.success(res.msg);
            setTimeout(() => {
              $router.go(-1);
              form.value.replys = [];
            }, 1000);
          } else {
            setTimeout(hide);
            message.error(res.msg);
          }
        })
        .catch((error) => {
          message.error("请完善表单！");
        });
    };
    onMounted(() => {
      getTag();
      getType();
      if ($route.query.type == "edit" || $route.query.type == "look") {
        getMore($route.query.id);
      }
    });
    return {
      form,
      ...toRefs(state),
      ruleForm,
      onSubmit,
      getMore,
      addTextOpen,
      addTextItem,
      selectImg,
      success,
      openSelectImgText,
      delreplyItem,
    };
  },
};
</script>
